import { createReducer } from "../../../../../generic/redux/createReducer";
import { pairActionTypeToReducer } from "../../../../../generic/redux/TypedRedux";

import type { SetStackPacksIndexFilter } from "./StackPacksIndexActions";
import { SET_STACK_PACKS_INDEX_FILTER } from "./StackPacksIndexActionTypes";
import { type StackPacksIndexState, initialStackPacksIndexState } from "./StackPacksIndexState";

const setFilter = (state: StackPacksIndexState, action: SetStackPacksIndexFilter): StackPacksIndexState => ({
	...state,
	filter: action.filter,
});

export const StackPacksIndexReducer = createReducer(initialStackPacksIndexState, {
	...pairActionTypeToReducer(SET_STACK_PACKS_INDEX_FILTER, setFilter),
});
